var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmartSensor = function SvgSmartSensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.438 3C17.614 3 21 6.403 21 10.6c0 4.197-3.386 7.6-7.562 7.6a7.499 7.499 0 0 1-3.92-1.1H2.99a1.995 1.995 0 0 1-1.99-2v-9c0-1.105.891-2 1.99-2h6.527a7.499 7.499 0 0 1 3.92-1.1zm0 1.189c-3.523 0-6.38 2.87-6.38 6.411 0 3.54 2.857 6.411 6.38 6.411 3.523 0 6.379-2.87 6.379-6.411 0-3.54-2.856-6.411-6.38-6.411zm-5.419 1.11L2.99 5.3a.798.798 0 0 0-.796.8v9c0 .442.356.8.796.8h5.028a7.595 7.595 0 0 1-2.142-5.3 7.6 7.6 0 0 1 2.143-5.302zm2.993 1.542 2.335 2.365c.196-.086.41-.133.637-.133.883 0 1.6.72 1.6 1.607 0 .888-.717 1.607-1.6 1.607a1.603 1.603 0 0 1-1.599-1.607c0-.217.043-.425.12-.614L10.16 7.69a.604.604 0 0 1 .004-.852.598.598 0 0 1 .848.004z"
  })));
};

export default SvgSmartSensor;